/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, {ReactNode, useCallback, useEffect, useMemo, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import {KTSVG} from '../../../../_metronic/helpers'
import {getSalesAreaLetter} from '../../../../api/modules/getdatalist'
import {
  getBankDetail,
  getBankList,
  getSalesOrgAll,
} from '../../../../api/modules/master-data/master_2'
import {fetchBankAccounts, headers} from '../../../../services/fetcher'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  filterSelector,
  resetFilterBankAccount,
  setFilterBankAccount,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import CustomUseEffect from './CustomUseEffect'
import {RowFilter} from './RowFilter'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {StyledCard} from '../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'

type Props = {
  className: string
}

const TableBank: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterBankAccount} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const [bank, setBank] = useState<any[]>([])
  const [sales, setSales] = useState<any[]>([])
  const [listBank, setListBank] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [actived, setActived] = useState(false)
  const [isError, setIsError] = useState(false)

  const [salesOrgSelect, setSalesOrgSelect] = useState<any>()

  const getSalesOrgS = async () => {
    const res = await getSalesAreaLetter()
    setSalesOrgSelect(res.data.data)
  }

  useEffect(() => {
    const getSales = async () => {
      setLoading(true)
      const res = await getSalesOrgAll()
      const data = res.data.data
      setSales(data)
    }
    const getListBank = async () => {
      setLoading(true)
      const res = await getBankList()
      const data = res.data.data
      setListBank(data)
    }

    getListBank()
    getSales()
    getSalesOrgS()
  }, [])

  const [salesOrg, setSalesOrg] = useState('')
  const [bankCode, setBankCode] = useState('')
  const [bankAcc, setBankAcc] = useState('')
  const [bankGl, setBankGl] = useState('')
  const [bankClearing, setBankClearing] = useState('')
  const [currency, setCurrency] = useState('')
  const [Status, setStatus] = useState('')

  const handleCreate = async () => {
    axios
      .post(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/bank/bank-account/create?credentials=${localStorage.getItem('credential')}`,
        {
          sales_org_code: salesOrg,
          bank_code: bankCode,
          bank_account: bankAcc,
          bank_gl_account: bankGl,
          bank_clearing_acct: bankClearing,
          currency: currency,
          status: Status,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((res) => {
        handleClose()
        swal({
          title: `${t('Bank Added Successfully')}`,
          icon: 'success',
        }).then(() => {
          onFetchBankAccounts()
          setActived(!actived)
        })
      })
      .catch((err) => {
        swal({
          title: t(err.response.data.message),
          icon: 'error',
        })
      })
  }

  const handleDelete = async (id: any) => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          await axios
            .delete(
              `${
                process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
              }/bank/bank-account/delete/${id}?credentials=${localStorage.getItem('credential')}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            .then((response) => {
              if (!response.data.error) {
                swal({
                  title: `${t('Bank Deleted Successfully')}`,
                  icon: 'success',
                }).then(() => {
                  onFetchBankAccounts()
                  setActived(!actived)
                })
              }
            })
            .catch((error) => {})
        }
      })
      .catch((err) => {
        swal({
          title: `${t('Data Failed to Delete')}`,
          icon: 'error',
        })
      })
  }

  const [editId, setEditId] = useState('')
  const [editSalesOrg, setEditSalesOrg] = useState('')
  const [editSalesOrgName, setEditSalesOrgName] = useState('')
  const [editBankCode, setEditBankCode] = useState('')
  const [editBankAccount, setEditBankAccount] = useState('')
  const [editBankGl, setEditBankGl] = useState('')
  const [editBankClearing, setEditBankClearing] = useState('')
  const [editCurrency, setEditCurrency] = useState('')
  const [editStatus, setEditStatus] = useState('')

  const handleEdit = async (id: any) => {
    handleShow1()
    setLoading(true)
    const res = await getBankDetail(id)
    const data = res.data.data
    setEditId(data.id)
    setSalesOrg(data.sales_org_code)
    setEditSalesOrg(data.sales_org_code)
    setEditSalesOrgName(data.sales_org?.name)
    setEditCurrency(data.currency)
    setEditBankCode(data.bank_code)
    setEditBankAccount(data.bank_account)
    setEditBankGl(data.bank_gl_account)
    setEditBankClearing(data.bank_clearing_acct)
    setEditStatus(data.status)
    setLoading(false)
  }

  const editBank = async (id: any) => {
    axios
      .put(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/bank/bank-account/edit/${editId}?credentials=${localStorage.getItem('credential')}`,
        {
          sales_org_code: editSalesOrg,
          bank_code: editBankCode,
          bank_account: editBankAccount,
          bank_gl_account: editBankGl,
          bank_clearing_acct: editBankClearing,
          currency: editCurrency,
          status: editStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((res) => {
        handleClose1()
        swal({
          title: `${t('Bank Edited Successfully')}`,
          icon: 'success',
        }).then(() => {
          onFetchBankAccounts()
          setActived(!actived)
        })
      })
      .catch((err) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
  }

  const rowNumber = useMemo(() => {
    const per = filterBankAccount?.per_page ?? 5
    return page * per - per
  }, [filterBankAccount, page])

  const onFetchBankAccounts = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchBankAccounts(filterBankAccount)
      .then((res) => {
        setBank(res.data.data.data)
        setNumberURL(res.data.data.links)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterBankAccount])

  const paginateNumber = async (number: any) => {
    if (!number) return

    try {
      setLoading(true)

      const token = localStorage.getItem('token')
      const endpoint = `${number}&${objToParams(filterBankAccount)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setBank(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const getData = setTimeout(() => onFetchBankAccounts(), 1000)
    return () => clearTimeout(getData)
  }, [onFetchBankAccounts])

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterBankAccount({...filterBankAccount, per_page: value ?? 5}))
  }

  const handleResetTable = () => {
    dispatch(resetFilterBankAccount())
  }

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 8,
    onReloadTable: handleResetTable,
  })

  const [role, setRole] = useState(localStorage.getItem('role-flag'))
  useEffect(() => {
    try{
      if(role != 'admin'){
        const _tempaccessdata = JSON.parse(localStorage.getItem('accesses')!)
        setSalesOrg(_tempaccessdata.sales_org_code)
      }
    }catch{}
  }, [role])

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterBankAccount?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          <button
            onClick={handleShow}
            className='btn btn-primary d-flex align-items-center'
            title={t('tambah_bank')}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
            {t('order-tambah')}
          </button>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('TableBank.No')}</th>
              <th>{t('TableBank.sales_org')}</th>
              <th>{t('mataUang')}</th>
              <th>{t('TableBank.bank_code')}</th>
              <th>{t('TableBank.bank_account')}</th>
              <th>{t('TableBank.bank_gl_account')}</th>
              <th>{t('TableBank.bank_clearing_acct')}</th>
              <th>{t('TableBank.status')}</th>
              <th>{t('TableBank.action')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : bank?.length === 0 ? (
              <RowEmptyData />
            ) : (
              bank.map((item: any, index: number) => (
                <tr key={item?.id ?? index}>
                  <td>{index + 1 + rowNumber}</td>
                  <td>{item?.sales_org?.name}</td>
                  <td>{item?.currency}</td>
                  <td>{item?.bank_code}</td>
                  <td>{item?.bank_account}</td>
                  <td>{item?.bank_gl_account}</td>
                  <td>{item?.bank_clearing_acct}</td>
                  <td>
                    <span className='d-block '>
                      {item?.status === 1 ? (
                        <span className='badge badge-light-success'>{t('Active')}</span>
                      ) : (
                        <span className='badge badge-light-danger'>{t('Non-Active')}</span>
                      )}
                    </span>
                  </td>
                  <td>
                    <div className='d-flex justify-content-center'>
                      <button
                        onClick={() => handleEdit(item.id)}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                        title={t('ubah')}
                      >
                        <KTSVG path='/media/icons/duotune/pencil-fill.svg' />
                      </button>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        title={t('Hapus')}
                        onClick={() => handleDelete(item.id)}
                      >
                        <KTSVG path='/media/icons/duotune/trash-fill.svg' />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal show={show1} onHide={handleClose1} centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')} Bank</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className='d-flex justify-content-center'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <>
              { role == 'admin' && <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>Sales Org</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  onChange={(e: any) => setSalesOrg(e.target.value)}
                >
                  <option>{t('pilih')} Sales Org</option>
                  {sales.map((items: any) => (
                    <>
                      {editSalesOrgName == items.name ? (
                        <option value={editSalesOrgName} selected>
                          {editSalesOrgName}
                        </option>
                      ) : (
                        <option value={items.code}>{items.name}</option>
                      )}
                    </>
                  ))}
                </Form.Select>
                {/* <Form.Select aria-label="Default select example" id='code' onChange={e => setEditSalesOrg(e.target.value)}>
                              {sales.map((items: any) => (
                                <>
                                  {editSalesOrgName == items.name ? (
                                    <option value={salesOrg} selected>{editSalesOrgName}</option>
                                  ) : (
                                    <option value={items.code}>{items.name}</option>
                                  )}
                                </>
                              ))}
                            </Form.Select> */}
              </Form.Group> }
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('mataUang')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='code'
                  onChange={(e: any) => setEditCurrency(e.target.value)}
                >
                  {['IDR', 'USD'].map((item: any) => (
                    <>
                      {editCurrency == item ? (
                        <option value={item} selected>
                          {item}
                        </option>
                      ) : (
                        <option value={item}>{item}</option>
                      )}
                    </>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>Bank</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='code'
                  onChange={(e: any) => setEditBankCode(e.target.value)}
                >
                  {/* <option value={editBankCode} selected hidden>{editBankCode}</option> */}
                  {listBank.map((items: any) => (
                    <>
                      {editBankCode == items.code ? (
                        <option value={editBankCode} selected>
                          {editBankCode}
                        </option>
                      ) : (
                        <option value={items.code}>{items.code}</option>
                      )}
                    </>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('Bank Account')}</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={t('Bank Account')}
                  defaultValue={editBankAccount}
                  onChange={(e: any) => setEditBankAccount(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>{t('Bank Clearing')}</Form.Label>
                <Form.Control
                  type='text'
                  placeholder={t('Bank Clearing')}
                  defaultValue={editBankGl}
                  onChange={(e: any) => setEditBankGl(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>Bank GL</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Bank GL'
                  defaultValue={editBankClearing}
                  onChange={(e: any) => setEditBankClearing(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-8' controlId='formBasicEmail'>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  id='code'
                  onChange={(e: any) => setEditStatus(e.target.value)}
                >
                  {editStatus == '1' ? (
                    <>
                      <option value={0}>{t('Inactive')}</option>
                      <option selected value={1}>
                        {t('Active')}
                      </option>
                    </>
                  ) : (
                    <>
                      <option selected value={0}>
                        {t('Inactive')}
                      </option>
                      <option value={1}>{t('Active')}</option>
                    </>
                  )}
                </Form.Select>
              </Form.Group>
              <div className='d-flex justify-content-end'>
                <button className='btn btn-primary' onClick={editBank}>
                  {t('ubah')}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('add')} Bank</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { role == 'admin' &&  <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Sales Org</Form.Label>
            <Form.Select
              aria-label='Default select example'
              onChange={(e: any) => setSalesOrg(e.target.value)}
            >
              <option>{t('pilih')} Sales Org</option>
              {sales.map((items: any, index: number) => (
                <option key={items?.code ?? index} value={items.code}>
                  {items.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group> }
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('mataUang')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='uang'
              onChange={(e: any) => setCurrency(e.target.value)}
            >
              {['IDR', 'USD'].map((item: any) => (
                <>
                  {currency == item ? (
                    <option value={item} selected>
                      {item}
                    </option>
                  ) : (
                    <option value={item}>{item}</option>
                  )}
                </>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Bank</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='bank'
              onChange={(e: any) => setBankCode(e.target.value)}
            >
              <option>{t('pilih')} Bank</option>
              {listBank.map((items: any, index: number) => (
                <option key={items?.code ?? index} value={items.code}>
                  {items.code}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Bank Account')}</Form.Label>
            <Form.Control
              type='number'
              id='Bank_acc'
              placeholder={t('Bank Account')}
              onChange={(e: any) => setBankAcc(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Bank Clearing')}</Form.Label>
            <Form.Control
              type='number'
              id='Bank_clear'
              placeholder={t('Bank Clearing')}
              onChange={(e: any) => setBankClearing(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Bank GL</Form.Label>
            <Form.Control
              type='number'
              id='Bank_gl'
              placeholder='Bank GL'
              onChange={(e: any) => setBankGl(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>Status</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='status'
              onChange={(e: any) => setStatus(e.target.value)}
            >
              <option>{t('pilih')} Status</option>
              <option value='0'>{t('Non-Active')}</option>
              <option value='1'>{t('Active')}</option>
            </Form.Select>
          </Form.Group>
          <div className='d-flex justify-content-end'>
            <button className='btn btn-primary' onClick={handleCreate}>
              {t('buat')}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableBank}
